/**
 * Renders the pagination for the feed.
 * @param {Object} feed - The feed object containing pagination data.
 */
export default function renderPagination(feed) {
	if (feed !== undefined && feed.per_page !== undefined) {
		const numPages = Math.ceil(feed.total_posts / feed.per_page);
		const currentPage = Number(feed.current_page);

		if (numPages > 1) {
			let html = `<nav class="govuk-pagination mx-auto" role="navigation" aria-label="Pagination"><ul class="govuk-pagination__list">`;
			let i = 1;
			let active = '';
			let skipLink = false;

			while (i <= numPages) {
				active = '';
				if (i === currentPage) {
					active = ' govuk-pagination__item--current';
				}
				if (i === 1 && currentPage > 1) {
					html += `<div class="govuk-pagination__prev">
					<a class="govuk-link govuk-pagination__link js-gsfc-filter-pagination prev" href="#" rel="prev" data-page="${
						currentPage - 1
					}">
					  <svg class="govuk-pagination__icon govuk-pagination__icon--prev" xmlns="http://www.w3.org/2000/svg" height="13" width="15" aria-hidden="true" focusable="false" viewBox="0 0 15 13">
						<path d="m6.5938-0.0078125-6.7266 6.7266 6.7441 6.4062 1.377-1.449-4.1856-3.9768h12.896v-2h-12.984l4.2931-4.293-1.414-1.414z"></path>
					  </svg>
					  <span class="govuk-pagination__link-title">
						Previous<span class="govuk-visually-hidden"> page</span>
					  </span>
					</a>
				  </div>`;
				}

				// Truncate page links for large number of results, display ellipses the first time links are skipped
				if (
					i === 1 ||
					i === currentPage - 1 ||
					i === currentPage ||
					i === currentPage + 1 ||
					i === numPages
				) {
					html += `<li class="govuk-pagination__item${active}"><a href="#" class="govuk-link govuk-pagination__link js-gsfc-filter-pagination" data-page="${i}">${i}</a></li>`;
					skipLink = true;
				} else if (skipLink) {
					html += `<li class="govuk-pagination__item">...</li>`;
					skipLink = false;
				}

				if (i === numPages && currentPage < numPages) {
					html += `<div class="govuk-pagination__next">
					<a class="govuk-link govuk-pagination__link js-gsfc-filter-pagination next" href="#" rel="next" data-page="${
						currentPage + 1
					}">
					  <span class="govuk-pagination__link-title">
						Next<span class="govuk-visually-hidden"> page</span>
					  </span>
					  <svg class="govuk-pagination__icon govuk-pagination__icon--next" xmlns="http://www.w3.org/2000/svg" height="13" width="15" aria-hidden="true" focusable="false" viewBox="0 0 15 13">
						<path d="m8.107-0.0078125-1.4136 1.414 4.2926 4.293h-12.986v2h12.896l-4.1855 3.9766 1.377 1.4492 6.7441-6.4062-6.7246-6.7266z"></path>
					  </svg>
					</a>
				  </div>`;
				}

				i++;
			}
			html += '</ul></nav>';
			document.querySelector('.js-gsfc-feed-pagination').innerHTML = html;
		} else {
			document.querySelector('.js-gsfc-feed-pagination').innerHTML = '';
		}
	}
}
